import { _SaveLead } from "./_SaveLead";
import {
  _DispathSaveHookLead,
  _SendLeadToSaveInHooks,
} from "./_DispathSaveHookLead";
import { _FindLead } from "./_FindLead";
/**
 * Serviço para salvar Leads - Nova Jornada
 */
export class LeadService {
  constructor(req, res) {
    this.req = req;
    this.res = res;
  }

  save = async (dataLead) => {
    const resultSaveLead = await _SaveLead(dataLead, this);
    return resultSaveLead;
  };

  find = async (id = null) => {
    return await _FindLead({ id, context: { req: this.req, res: this.res } });
  };

  findByEmail = async (email) => {
    return await _FindLead({ email, context: { req: this.req, res: this.res } });
  };

  dispathSaveHookLead = async (dataLead) =>
    _DispathSaveHookLead(dataLead, { req: this.req, res: this.res });
}
